import { lazy } from 'react';

export const LazyRecoverPasswordPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--recover-password-page" */ './recover-password-page'
    ),
);
